module.exports = __webpack_public_path__ + "img/quantstamp.ad0b41d0.png";